/**
 * Component Registry for Malvern Hill Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-vantage and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-vantage/registry';
import { FAQList } from './components/FAQList';
import { FloorplansList } from './components/FloorplansList';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { HeroSolidBG } from './components/HeroSolidBG';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { NeighborhoodSection } from './components/NeighborhoodSection';
import { PropertyOverview } from './components/PropertyOverview';
import { SisterProperties } from './components/SisterProperties';
import { SitemapContent } from './components/SitemapContent';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  FAQList,
  FloorplansList,
  Footer,
  Hero,
  HeroSolidBG,
  NeighborhoodMap,
  NeighborhoodSection,
  PropertyOverview,
  SisterProperties,
  SitemapContent,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
